export enum ContactType {
    Company = 1,
    Individual
}